import React, { useState } from 'react';
import propTypes from 'prop-types';

const TextBox = (props) => {
  const { label, rows, value, onChange } = props;
  const [inputvalue, setValue] = useState(value || '');

  // Controlled ONLY when the parent supplies an onChange (it then owns the value via state).
  // Decide on `onChange`, not `value`: keying on `value` made a caller that passes `value`
  // WITHOUT `onChange` (e.g. TradeClubLink/PriorityCardLink with value="") a controlled input
  // bound to a constant that nothing could update — i.e. an un-typeable, frozen field.
  // When uncontrolled, `value` is used only to seed the initial internal state.
  const isControlled = onChange !== undefined;
  const inputVal = isControlled ? (value ?? '') : inputvalue;
  const handleChange = isControlled ? onChange : (evt) => setValue(evt.target.value);

  return (
    <div className="input-form">
      <div className="input-form__wrapper">
        <div className="floating-label">
          {rows === null ? (
            <input
              className="form-input"
              onChange={handleChange}
              value={inputVal}
            />
          ) : (
            <textarea
              className="form-input"
              rows={rows}
              onChange={handleChange}
              value={inputVal}
            />
          )}
          {label ? (
            <label
              className={`${inputVal.length && 'float'} form-input-label`}
            >
              {label}
            </label>
          ) : null}
        </div>
      </div>
    </div>
  );
};

TextBox.defaultProps = {
  label: null,
  rows: null,
  value: undefined,
  onChange: undefined,
};

TextBox.propTypes = {
  label: propTypes.string,
  rows: propTypes.string,
  value: propTypes.string,
  onChange: propTypes.func,
};

export default TextBox;
